import { IntlShape } from 'react-intl';
import { FormEvent } from 'react';
import { errorCodeKeys } from './mappings/еrrorCodeKeys';
import { globalConfig } from "../configuration/config";

export const getTranslationForCode = (code: string, intl: IntlShape): string => {
    try {
        const key = errorCodeKeys[code];
        let translation;
        if (key) {
            translation = intl?.messages[key];
        }
        if (!translation) {
            translation = intl?.messages["error.unexpected"]
        }
        return translation?.toString();
    }
    catch (error) {
        console.error("error translating message");
    }
    return intl?.messages["error.unexpected"].toString();
}

export const getTranslationForCodeWithReplacements = (code: string, intl: IntlShape, replacements: { [index: string]: string }): string => {
    try {
        const key = errorCodeKeys[code];
        let translation: string = "";
        if (key) {
            translation = intl?.messages[key]?.toString();
        }
        if (translation) {
            let t: keyof { [index: string]: string };
            for (t in replacements) {
                translation = translation.replace(`{${t}}`, replacements[t]);
            }
            return translation;
        }
    }
    catch (error) {
        console.error("error translating message");
    }
    return intl?.messages["error.unexpected"].toString();
}

export const getLocale = (): string => {
    try {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let language: string = urlParams.get('ui_locales') || '';
        return language ? language.split('-')[0] : globalConfig.config.DefaultLanguage;
    }
    catch (ex) {
        return globalConfig.config.DefaultLanguage;
    }
}
